export const SOURCE_FRESHNESS_MS = 60 * 60 * 1000;

export function getSourceFreshness(source, now = Date.now()) {
  const lastSuccessAt = source?.lastSuccessAt || (source?.ok === true ? source?.checkedAt : null) || null;
  const parsedSuccess = lastSuccessAt ? Date.parse(lastSuccessAt) : NaN;
  const validSuccessAt = Number.isFinite(parsedSuccess) ? lastSuccessAt : null;
  const ageMs = validSuccessAt ? Math.max(0, now - parsedSuccess) : null;

  if (source?.ok === false && source?.checkedAt) return { state: 'failed', lastSuccessAt: validSuccessAt, ageMs };
  if (!validSuccessAt) return { state: 'unknown', lastSuccessAt: null, ageMs: null };
  return { state: ageMs <= SOURCE_FRESHNESS_MS ? 'fresh' : 'stale', lastSuccessAt: validSuccessAt, ageMs };
}
